// Centralised task priority styling
// Levels: normal | priority | urgent
// Yellow = priority, Red = urgent

export const PRIORITY_LEVELS = ["normal", "priority", "urgent"];

export function priorityStyle(level) {
  switch (level) {
    case "urgent":
      return {
        // Solid red background, white text for maximum contrast
        bg: "bg-red-600",
        text: "text-white",
        border: "border-red-700",
        // Left bar accent for list rows
        bar: "bg-red-600",
        // Chip badge styling (small label on calendar/lists)
        chip: "bg-red-600 text-white border-red-700",
        // Calendar chip overlay: thick red border
        calendarBorder: "border-red-700 ring-2 ring-red-500 ring-inset",
        label: "URGENT",
        labelEs: "URGENTE",
        dot: "#DC2626",
      };
    case "priority":
      return {
        bg: "bg-amber-400",
        text: "text-black",
        border: "border-amber-500",
        bar: "bg-amber-400",
        chip: "bg-amber-300 text-black border-amber-500",
        calendarBorder: "border-amber-500 ring-2 ring-amber-400 ring-inset",
        label: "PRIORITY",
        labelEs: "PRIORITARIA",
        dot: "#F59E0B",
      };
    default:
      return {
        bg: "",
        text: "",
        border: "",
        bar: "",
        chip: "",
        calendarBorder: "",
        label: "NORMAL",
        labelEs: "NORMAL",
        dot: "",
      };
  }
}
